import { Injectable, Injector } from '@angular/core';

import { BaseCrudService } from 'projects/ProjetoBaseAngular/domain/services/base-crud.service';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MenuModel } from '../models';

@Injectable({
  providedIn: 'root'
})
export class MenuService extends BaseCrudService<MenuModel> {

  constructor(injector: Injector) {
    super(injector);
  }

  public getController(): string {
    return 'Menu';
  }

  getAll(): Observable<MenuModel[]> {
    return this
      .httpClient
      .get<MenuModel>(`${this.getApiUrl()}${this.getController()}`, this.getHeaderJson())
      .pipe(
        map(this.extractData)
      );
  }

  updateOrdens(menuIds) {
    return this
      .httpClient
      .post(`${this.getApiUrl()}${this.getController()}/UpdateOrdens`, menuIds, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }
}
